import Controller from "@ember/controller"
import { action, computed, get } from "@ember/object"
import { inject as service } from "@ember/service"
import { handleError } from "cc-frontend/error-handling"
import belongsTo from "cc-frontend/helpers/belongs-to"
import PLANBOOK_UNDELETE from "cc-frontend/lib/actions/planbook/PLANBOOK_UNDELETE"
import _ from "lodash"
import moment from "moment"

export default class Planbookv5Controller extends Controller {
  @service router
  @service dispatcher
  @service("ember-store") store
  @service session
  @service dialog
  @service rpc
  @service windowscroll

  @belongsTo("model.planbook", "owner") owner

  queryParams = ["hideNav"]

  @computed("router.currentRouteName")
  get isInPlannerRoute() {
    return _.includes(get(this, "router.currentRouteName"), "planbookv5.planner")
  }

  @computed("router.currentRouteName")
  get isInLinkShareableRoute() {
    const linkShareableRoutes = [
      "planbookv5.planner.day",
      "planbookv5.planner.week",
      "planbookv5.planner.month",
      "planbookv5.planner.timeline",
      "planbookv5.planner.outline",
      "planbookv5.standards-tracker",
    ]
    return _.includes(linkShareableRoutes, get(this, "router.currentRouteName"))
  }

  @computed("router.currentRouteName")
  get isInSetupRoute() {
    return _.includes(get(this, "router.currentRouteName"), "planbook.setup")
  }

  constructor() {
    super(...arguments)
    if (window) {
      window.CCIMPERSONATE_PLANBOOK = () => {
        get(this, "session").impersonateUserId(
          get(this, "model.planbook.relationships.owner.data.id"),
          window.location.href
        )
      }
    }
  }

  @action
  deletePlanbook() {
    get(this, "dialog")
      .blank("dialogs/confirm-delete-planbook", {
        className: "dialog--create-annotation",
      })
      .then(() => {
        get(this, "rpc")
          .execute("PLANBOOK_DELETE", get(this, "model.planbook.id"))
          .then(() => {
            window.location.href = "/users/" + get(this, "owner.id")
            // Ember.getOwner(this).lookup('router:main').transitionTo('user.show.index', get(this, "owner.id"))
          })
      })
      .catch((error) => {
        if (error instanceof Error) handleError(error)
      })
  }

  @action signInOrUp(e) {
    console.log("router, this.router", this.get("router"), this.router.currentURL)
    e.preventDefault()

    this.router.transitionTo("user.sign", {
      queryParams: { afterSignInRedirectTo: this.router.currentURL },
    })
  }

  @action undeletePlanbook(planbook) {
    get(this, "dispatcher").dispatchAction(PLANBOOK_UNDELETE, {
      planbookId: planbook.id,
      userId: planbook.relationships.owner.data.id,
      classWebsiteIds: (planbook.relationships.classWebsites?.data ?? []).map(
        (linkage) => linkage.id
      ),
      timestamp: moment().format(),
    })
  }
}
